import {cs} from "../../../../react/chain-services";
import {consumeContext} from "../../../../react/context";
import {UseState} from "../../../../react/use-state";
import {fragments} from "../../../../react/fragments";
import {Invoke} from "../../../../react/invoke";

export const CallingGetCass = ({mailingLists, mailingListIds, entityId, next}) => cs(
    consumeContext("apis"),
    ["called", (_, next) => UseState({
        initValue: [],
        next,
    })],
    ["calling", (_, next) => UseState({
        initValue: [],
        next,
    })],
    ({apis, calling, called}) => fragments(
        next({
            isActive: (mlId) => calling.value.includes(mlId),
            invoke: async (mlId) => {
                if (called.value.findIndex((id) => id == mlId) > -1) {
                    return;
                }
                calling.change((_) => [..._, mlId]);
                const cassResult = await apis.next.mailing.getCass(mlId, entityId, {doNotWait: false});
                if (cassResult.count != mailingLists.value.find(list => list.id == mlId).count) {
                    await mailingLists.reload();
                }
                calling.change((_) => _.filter((id) => id !== mlId));
            },
        }),

        (mailingListIds?.findIndex((mlId) => called.value.findIndex((id) => id == mlId) === -1) > -1) && (
            Invoke({
                fn: () => {
                    called.change((_) => [
                        ..._,
                        ...mailingListIds.filter((mlId) => called.value.findIndex((id) => id == mlId) === -1),
                    ]);
                },
            })
        ),
    ),
);
